import { LoanRequest_DocumentsDemanded } from 'cpool-events';
// import type { EventSchema } from 'cpool-events';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

// export type DemandedDocumentsTableSchema = {
//     documents: Array<{
//         attribution: EventSchema<LoanRequest_DocumentsDemanded>['attribution'];
//         demandedDate: number;
//         name: string;
//     }>;
//     id: string;
// };

export const DemandedDocumentsTableDefinitionZod = z.object({
    documents: z.array(
        z.object({
            attribution: LoanRequest_DocumentsDemanded.prototype.getSchema().shape.attribution,
            demandedDate: z.number(),
            name: z.string(),
            providedDate: z.number().optional(),
        }),
    ),
    id: schemaId,
});

export type DemandedDocumentsTableSchema = z.infer<typeof DemandedDocumentsTableDefinitionZod>;
